this.window.quickCommonsExports = (function(funcs){
  var exports = this.window.sundayinlineexports

  exports = funcs.errorPopup(exports)
  exports = funcs.initCheapScrolling(exports);
  exports = funcs.discountPopup(exports);
  exports = funcs.sharePopup(exports);
  exports = funcs.playVideosListener(exports);
  exports = funcs.technoPopup(exports);
  exports = funcs.technoBtns(exports);
  exports = funcs.copyBtn(exports);

  return exports

})({
  sharePopup: function(exports){
    var sharePopup = document.querySelector('.share_pp');
    if(!sharePopup) return exports;
    var fineprint = document.querySelector('.sh_fine_print ');

    decorate(sharePopup, [{
      key: 'hide',
      value: function(){
        this.classList.add('opacity_hidden')
        setTimeout(function(that){ that.classList.add('away') }, 400, this)
      }
    },
    {
      key: 'listenForLIShare',
      value: function(){
        var btn = document.querySelector('.top_banner .cta a')

        btn.addEventListener('click', function(event){
          event.preventDefault()
          window.open('https://www.linkedin.com/uas/oauth2/authorization?response_type=code&client_id=86p183e6dtvtap&redirect_uri='+encodeURIComponent('http://brester.tech')+'&state=asdasdqqqfgsdfdasd12312as&scope=r_liteprofile%20w_member_social')
        })

        /*
        if(getParameterByName('code')){
          window.location.replace('https://www.linkedin.com/oauth/v2/accessToken?grant_type=authorization_code&code='+getParameterByName('code')+'&redirect_uri='+encodeURIComponent('https://' + location.host + location.pathname)+'&client_id=86p183e6dtvtap&client_secret=le6GRNR1zksdrQs8')
        }
        */
      }
    }])

    var closeBtn = sharePopup.querySelector('.close_btn')

    closeBtn && closeBtn.addEventListener('click', function(){
      sharePopup.hide()
      exports.dummyWindow.unfix()
    })

    var initiated = false

    var handler = function(res){
      if(res && !res.error_message){
        sharePopup.hide()
        exports.discountPopup.startCountdown()
        exports.discountPopup.show()
      } else {
        sharePopup.hide()
        exports.errorPopup.show()
      }
    }

    var shareBtn = sharePopup.querySelector('.sh_close_pp')
    shareBtn && shareBtn.addEventListener('click', function(){
      fineprint.classList.remove('opacity_hidden')

      if(!initiated){
        initiated = true

        window.fbAsyncInit = function(){
          FB.ui({
            method: 'share',
            title: 'Sunday Manifacturing',
            description: 'Sunday Manifacturing video', 
            href: sharePopup.getAttribute('data-link')
          }, handler)
        }

        appendScript("https://connect.facebook.net/en_US/sdk/debug.js#version=v3.3&appId=436327899862629&status=true&cookie=true&xfbml=false", {})
      } else {
        FB.ui({
          method: 'share',
          href: sharePopup.getAttribute('data-link')
        }, handler)
      }
    })

    exports.sharePopup = sharePopup

    return exports;
  },
  discountPopup: function(exports){
    var discountPopup = document.querySelector('.discount_pp')

    if(!discountPopup) return exports

    var daysText = discountPopup.querySelector('.sh_timer_sec:nth-child(1) .sh_timer_numbers')
    var hoursText = discountPopup.querySelector('.sh_timer_sec:nth-child(2) .sh_timer_numbers')
    var minutesText = discountPopup.querySelector('.sh_timer_sec:nth-child(3) .sh_timer_numbers')
    var secondsText = discountPopup.querySelector('.sh_timer_sec:nth-child(4) .sh_timer_numbers')

    decorate(discountPopup, [{
      key: 'show',
      value: function(){
        this.classList.remove('away')
        setTimeout(function(that){ that.classList.remove('opacity_hidden')}, 50, this)
      }
    },
    {
      key: 'hide',
      value: function(){
        this.classList.add('opacity_hidden')
        setTimeout(function(that){ that.classList.add('away')}, 400, this)
      }
    },
    {
      key: 'startCountdown',
      value: function(){
        var date = new Date(this.getAttribute('data-date'))

        var showTime = function(){
          var now = new Date()
          var diff = date.getTime() - now.getTime()

          daysText.textContent = zeroes(Math.floor(diff / (1000 * 3600 * 24 )))
          hoursText.textContent = zeroes(Math.floor((diff % (1000 * 3600 * 24 )) / (1000 * 3600)))
          minutesText.textContent = zeroes(Math.floor((diff % (1000 * 3600 )) / (1000 * 60)))
          secondsText.textContent = zeroes(Math.floor((diff % (1000 * 60 )) / (1000)))
        }

        showTime()

        this.interval = setInterval(showTime, 1000)
      }
    },
    {
      key: 'stopCountdown',
      value: function(){
        clearInterval(this.interval);
      }
    }])

    discountPopup.querySelectorAll('.sh_close_pp, .close_btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        discountPopup.stopCountdown();
        discountPopup.hide();
        exports.dummyWindow.unfix();
      })
    })

    exports.discountPopup = discountPopup

    return exports
  },
  errorPopup: function(exports){
    var errorPopup = document.querySelector('.pp_error')

    if(!errorPopup) return exports

    decorate(errorPopup, [{
      key: 'show',
      value: function(){
        this.classList.remove('away')
        setTimeout(function(that){ that.classList.remove('opacity_hidden')}, 50, this)
      }
    },
    {
      key: 'hide',
      value: function(){
        this.classList.add('opacity_hidden')
        setTimeout(function(that){ that.classList.add('away')}, 200, this)
        exports.dummyWindow.unfix()
      }
    }])

    errorPopup.querySelector('.close_pp').addEventListener('click', function(){
      errorPopup.hide()
    })

    var handler = function(res){
      if(res && !res.error_message){
        errorPopup.hide()
        exports.discountPopup && exports.discountPopup.startCountdown()
        exports.discountPopup && exports.discountPopup.show()
      }
    }

    errorPopup.querySelector('.retry_pp').addEventListener('click', function(){
      FB.ui({
        method: 'share',
        href: exports.sharePopup.getAttribute('data-link')
      }, handler)
    })

    exports.errorPopup = errorPopup

    return exports;
  },
  playVideosListener: function(exports){
    document.querySelectorAll('.play-video').forEach(function(item){
      // Get video ID
      let videoId = item.getAttribute('data-video-id')

      // Default options
      var settings = {
        videoID: videoId,
        autoPlay: 1,
        theme: "grtyoutube-dark-theme"
      }

      // Initialize on click

      item.addEventListener('click', function(){
        exports.dummyWindow.fix()

         $("body").append('<div class="grtyoutube-popup '+settings.theme+'">'+
              '<div class="grtyoutube-popup-content">'+
                '<span class="grtyoutube-popup-close"></span>'+
                '<iframe class="grtyoutube-iframe" src="https://www.youtube.com/embed/'+settings.videoID+'?rel=0&wmode=transparent&autoplay='+settings.autoPlay+'&iv_load_policy=3" allowfullscreen frameborder="0" allow="autoplay"></iframe>'+
              '</div>'+
            '</div>')

        let handler = function(event){
          let array = ['grtyoutube-popup-close', 'grtyoutube-popup']

          if(!(event.target.classList.contains(array[0]) || event.target.classList.contains(array[1]))) return

          document.removeEventListener('click', handler)
          exports.dummyWindow.unfix()
          $(".grtyoutube-popup").remove()
        }

        document.addEventListener('click', handler)
      })

      $(document).keyup(function(event) {
        if (event.keyCode == 27){
          handler()
        }
      });
    });

    return exports;
  },
  technoBtns: function(exports){
    var btns = document.querySelectorAll('.open-thn-btn')

    btns.forEach(function(btn){ btn.addEventListener('click', function(event){
      var pp = document.querySelector(btn.getAttribute('data-pp-selector'))
      exports.dummyWindow.hideHeader()
      exports.technoPopup.show()
      exports.dummyWindow.fix();
      exports.header.fix();
    })})

    return exports;
  },
  technoPopup: function(exports){
    var technoPopup = document.querySelector('.t_popup')
    if(!technoPopup) return exports;
    var closeBtn = technoPopup.querySelector('.back_btn')

    decorate(technoPopup, [{
      key: 'show',
      value: function(){
        this.classList.remove('away')
        setTimeout(function(that){
          that.classList.remove('opacity_hidden');
          closeBtn.classList.add('here');
          closeBtn.classList.remove('opacity_hidden');
        }, 50, this)
      }
    },
    {
      key: 'hide',
      value: function(){
        this.classList.add('opacity_hidden');
        closeBtn.classList.remove('here');
        closeBtn.classList.add('opacity_hidden');
        exports.dummyWindow.unfix()
        setTimeout(function(that){ that.classList.add('away')}, 400, this);
      }
    }])

    closeBtn.addEventListener('click', function(event){
      technoPopup.hide();
    })

    exports.technoPopup = technoPopup;

    return exports;
  },
  initCheapScrolling: function(exports){
    var elements = document.querySelectorAll('.cheap-scrolling')

    elements.forEach(function(element){ cheapScrolling(element) })

    return exports;
  },
  copyBtn: function(exports){
    if(!exports.discountPopup) return exports;
    var btn = exports.discountPopup.querySelector('.copy_icon');
    var confirm = exports.discountPopup.querySelector('.copy_confirm')
    var codeEl = exports.discountPopup.querySelector('.sh_code')

    var animate = function(){
      new Promise(function(resolve, reject){
        confirm.style.setProperty('display', 'block')
        setTimeout(function(){
          confirm.classList.remove('opacity_hidden')
          confirm.classList.add('float-small')
          setTimeout(function(){ resolve() }, 200)
        }, 50)
      })
        .then(function(){
          confirm.classList.add('opacity_hidden')
          setTimeout(function(){
            confirm.style.setProperty('display', 'none')
            confirm.classList.remove('float-small')
          }, 200)
        })
    }

    btn.addEventListener('click', function(event){
      var input = document.createElement('input');
      input.classList.add('hidden-input')
      input.value = codeEl.textContent;
      document.body.insertBefore(input, document.body.firstChild);
      input.focus();
      input.select();
      const result = document.execCommand('copy');
      if (result === 'unsuccessful') {
        confirm.textContent = 'Try again!'
        animate()
      } else {
        confirm.textContent = 'Copied!'
        animate()
      }
    })

    return exports;
  }
})

function cheapScrolling(container){
  if(!container) return;

  var scrollContainer = container.querySelector('.scrolling-element') || container

  var scrollPosition = 0

  var startScroll = 0

  var possibleScroll


  plainDetectTouch(container, startCallback, moveCallback, swipeCallback, )

  function moveCallback(offsetY){

    var temp = startScroll - offsetY

    setScroll(temp)
  }

  function startCallback(){
    possibleScroll = scrollContainer.scrollHeight - scrollContainer.clientHeight

    startScroll = scrollPosition
  }

  function swipeCallback(distance){
    var easing = function (t) { return t*(2-t) }

    var startTime = new Date().getTime()
    var duration = 300
    var endTime = startTime + duration
    var expoDistanse = distance * 3
    var startPos = scrollPosition

    var frame = function(){
      var current = new Date().getTime()
      var percent = (current - startTime) / duration

      var temp = startPos + (expoDistanse * easing(percent))

      setScroll(temp)

      if(percent < 1){
        requestAnimationFrame(frame)
      }
    }

    requestAnimationFrame(frame)
  }

  function plainDetectTouch(swipeTarget, startCallback, moveCallback, swipeCallback){
    // States: 0 - no swipe, 1 - swipe started
    var swipeState = 0;
    // Coordinates when swipe started
    var startX = 0;
    var startY = 0;
    // Distance of swipe
    var pixelOffsetX = 0;
    var pixelOffsetY = 0;

    var queue = new FixedQueue(50)

    var options = {
      // Amount of pixels, when swipe don't count.
      swipeThreshold: 50,
      // Flag that indicates that plugin should react only on touch events.
      // Not on mouse events too.
      useOnlyTouch: true
    }

    swipeTarget.addEventListener('touchstart', swipeStart)
    swipeTarget.addEventListener('touchmove', swiping)
    swipeTarget.addEventListener('touchend', swipeEnd)


    function swipeStart(event){
      event = event.touches[0];

      if (swipeState === 0) {
        swipeState = 1;
        startY = event.clientY;

        queue.refresh()
        startCallback()
      }
    }

    function swiping(event) {
      // If swipe don't occuring, do nothing.
      if (swipeState !== 1) return;
      event = event.touches[0];

      pixelOffsetY = event.clientY - startY;

      queue.push({ timestamp: new Date().getTime(), distance: pixelOffsetY })

      moveCallback(pixelOffsetY)
    }

    function swipeEnd(event) {
      swipeState = 0;
      var swipeDistance = queue.getDistanse(100)

      if(Math.abs(swipeDistance) > options.swipeThreshold){
        swipeCallback(swipeDistance)
      }
    }
  }

  /*
  scrol
  */

  scrollContainer.addEventListener('wheel', function(event){
    possibleScroll = scrollContainer.scrollHeight - scrollContainer.clientHeight
    var temp = scrollPosition + event.deltaY;

    setScroll(temp)
  })


  function setScroll(temp){
    if(temp > 0){
      (temp >= possibleScroll) ? scrollPosition = possibleScroll : scrollPosition = temp;
    } else {
      (temp <= 0 ) ? scrollPosition = 0 : scrollPosition = temp;
    }

    scrollContainer.scrollTop = scrollPosition;
  } 
}


function FixedQueue(size){
    this.list = []
    this.maxSize = size
}

FixedQueue.prototype.push = function(element){
  this.list.push(element)

  if(this.list.length > this.maxSize ){
    this.list.slice(0, this.maxSize)
  }
}

FixedQueue.prototype.getDistanse = function(millis){
  if(this.list.length == 0) return 0;

  var last = this.list[0]
  var distance

  this.list.forEach(function(item, index){
      if(item.timestamp - last.timestamp < millis ){
          distance = last.distance - item.distance
      }
  })

  return distance;
}

FixedQueue.prototype.refresh = function(){
  this.list = [];
}

//mini_cart JS

// $(window).on('resize',function(){
//   if($(window).width() < 767){
//     if(!$('.recommanded_slider_cart').hasClass('slick-initialized')){
//       $('.recommanded_slider_cart').slick({
//         infinite: false,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         dots: true,
//         arrows: false,
//         waitForAnimate: false
//       });
//     }
//   }else{
//     if($('.recommanded_slider_cart').hasClass('slick-initialized')){
//       $('.recommanded_slider_cart').slick('destroy');
//     }
//   }
// });

// $(document).ready(function(){  
//   function easeOutQuad(t) { return t*(2-t) }
//   function reviewcount(){
//   let number = document.querySelector('.minicart_counter_review');
//   if(!number) return;

//   var txt_date = document.querySelector(".mctxt_date").value;
//   var txt_value = document.querySelector(".mctxt_value").value;
//   var txt_count = document.querySelector(".mctxt_count").value;
//   var date1 = new Date(txt_date);
//   var date2 = new Date();
//   var diffTime = Math.abs(date2.getTime() - date1.getTime());
//   var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24) - 1);
//   document.querySelector(".minicart_counter_review").textContent = parseInt(txt_count)+(diffDays)*parseInt(txt_value) - parseInt(115);

//   let countingOptions = {
//     root: null,
//     ratio: 1.0
//   }
//   let countObserver = new IntersectionObserver((entries, observer) => {
//     if(!entries[0].isIntersecting) return ;
//     countObserver.unobserve(number)
//     let secondsCounter = 0
//     let percent = 0
//     let secondsInterval = setInterval(() => {
//       if(secondsCounter >= 30){
//         clearInterval(secondsInterval)
//         return
//       }
//       let newValue = easeOutQuad(secondsCounter/30) * 100
//       let delta = newValue - percent
//       percent = newValue;
//       let innerCounter = 0
//       let innerInterval = setInterval(() => {
//         if(innerCounter >= delta){
//           clearInterval(innerInterval)
//           return
//         }
//         number.innerHTML = parseInt(number.innerHTML) + 1
//         innerCounter ++
//       }, Math.floor(100/delta))

//       secondsCounter ++
//     }, 100)
//   });
//   countObserver.observe(number)
// }
//   if($('body').hasClass('has_minicart')){    
//     if($(window).width() < 767){
//       if(!$('.recommanded_slider_cart').hasClass('slick-initialized')){
//         $('.recommanded_slider_cart').slick({
//           infinite: false,
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           dots: true,
//           arrows: false,
//           waitForAnimate: false
//         });
//       }
//     } 
    
//     $('.body').on('click','.crt .cart_note_open',function(e){
//       $(this).closest('.messagebox-minicart').find('.cart').slideToggle();
//     });
//     $('.body').on('click','.crt #msg_box_cart_btn',function(e){
//       var form = $(this).closest('form');
//       $.ajax({
//         type: 'POST',
//         url: '/cart/update.js',
//         data: form.serialize(),
//         dataType: 'json',
//         error: function(jqXHR, textStatus, errorThrown){
//           var response = $.parseJSON(jqXHR.responseText);
//           alert(response.description);
//           $('#crt').removeClass('loading');
//         },
//         success: function(){
//           $('.messagebox-minicart .note_title').hide();
//           form.hide();          
//           $('.messagebox-minicart .success_msg').show();
//         }
//       });
//     });
//     $('.body').on('click','.cart_icon_wp',function(e){
//       e.preventDefault();
//       $('#crt,.cart_overlay').addClass('active');
//       $('body').addClass('active_crt');
//       reviewcount();
//     });
//     $('.body').on('click','#crt .quickclose_cart,.cart_overlay ',function(e){
//       e.preventDefault();
//       $('#crt,.cart_overlay').removeClass('active');
//       $('body').removeClass('active_crt');
//     });
//     $('.body').on('click','.protection_details .learn_more',function(e){
//       e.preventDefault();
//       $('.protection_plan_popup,.cart_overlay').addClass('prp_active');    
//     });
//     $('.body').on('click','.protection_plan_popup .popup_close',function(e){
//       e.preventDefault();
//       $('.protection_plan_popup,.cart_overlay').removeClass('prp_active');    
//     });

//     function addToCartSuccess() {
//       $.get( "/cart?view=mini", function( data ) {
//         $('#crt').html(data);
//         $('#crt').removeClass('loaderA');
//         if($(window).width() < 767){
//           if(!$('.recommanded_slider_cart').hasClass('slick-initialized')){
//             $('.recommanded_slider_cart').slick({
//               infinite: false,
//               slidesToShow: 1,
//               slidesToScroll: 1,
//               dots: true,
//               arrows: false,
//               waitForAnimate: false
//             });
//           }
//         }
//         reviewcount();
//       });
//     }
//     function refreshCart(cart) {
//       $('.quickcart_count').text('('+cart.item_count+')');
//       $('.c-cart-items').text(cart.item_count);
//     }
//     function update(ip,id){
//       $.ajax({
//         type: 'POST',
//         url: '/cart/update.js',
//         data: 'updates['+id+']='+ip,
//         dataType: 'json',
//         error: function(jqXHR, textStatus, errorThrown){
//           var response = $.parseJSON(jqXHR.responseText);
//           alert(response.description);
//           $('#crt').removeClass('loaderA');
//         }
//       }).done(function( data ) {
//         addToCartSuccess();
//         $.getJSON("/cart.js", function(cart) {
//           refreshCart(cart);
//         });
//       });
//     }


//     $('body').on('click','.adjust',function(e){
//       e.preventDefault();
//       $('#crt').addClass('loaderA');
//       var input = $(this).closest('.qtyAdjust').find('input');
//       var ip = parseInt(input.val());
//       if($(this).hasClass('plus')){
//         ip += 1;
//       }else{
//         ip -= 1;
//       }
//       if(ip <= 0){
//         $('#crt').removeClass('loaderA');
//         return false;      
//       }
//       input.val(ip);
//       var id = parseInt(input.attr('data-id'));
//       update(ip,id)    
//     });

//     $("#crt").on('click', "a.remove_item", function(r){
//       r.preventDefault();
//       $('#crt').addClass('loaderA');
//       var id = $(this).data("id");
//       update(0,id);
//     }); 

//     $('body').on('click','.product_protection #prt_box',function(){
//       $('#crt').addClass('loaderA');
//       var pid = $(this).attr('data-pid');
//       if ($(this).is(":checked")) {
//         $.ajax({
//           type: 'POST',
//           url: '/cart/add.js',
//           data: {
//             id: pid,
//             quantity: "1"
//           },
//           dataType: 'json',
//           error: function(jqXHR, textStatus, errorThrown){
//             var response = $.parseJSON(jqXHR.responseText);
//             $('#crt').removeClass('loaderA');
//           }
//         }).done(function( data ) {
//           addToCartSuccess();
//           $.getJSON('/cart.js', function(cart){
//             refreshCart(cart);
//           });
//         });
//       }else{
//         update(0,pid);
//       }
//     });
//     $('body').on('click','.recommended_products .recommanded_prd',function(){
//       $('#crt').addClass('loaderA');
//       var pid = $(this).closest('.form_wp').find('#option_selector').val();    
//       $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: {
//           id: pid,
//           quantity: "1"
//         },
//         dataType: 'json',
//         error: function(jqXHR, textStatus, errorThrown){
//           var response = $.parseJSON(jqXHR.responseText);
//           $('#crt').removeClass('loaderA');
//         }
//       }).done(function( data ) {
//         addToCartSuccess();
//         $.getJSON('/cart.js', function(cart){
//           refreshCart(cart);
//         });
//       });
//     });
//   }
  
// //   $('body').on('change','.form_wp #option_selector',function(){
// //     var price = $(this).find('option:selected').attr('data-price');
// //     $(this).closest('.form_wp').find('.price_area').html(price);
// //   });


// });
$(document).ready(function() {
  $('.acnav__label').click(function() {
    var label = $(this);
    var parent = label.parent('.has-children');
    var list = label.siblings('.acnav__list');
    if (parent.hasClass('is-open')) {
        list.slideUp('fast');
        parent.removeClass('is-open');
    } else {
        $('.acnav__list').slideUp('fast');
        $('.has-children').removeClass('is-open');
        list.slideDown('fast');
        parent.addClass('is-open');
    }
  });

  // $('body').on('click', '.menu_item .subtitle_2', function() {
  //   var parent = $(this).parent();
  //   if (parent.hasClass('hasOpen')) {
  //     parent.removeClass('hasOpen');
  //     parent.find('ul').slideUp('400');
  //   } else {
  //     $('.menu_item').removeClass('hasOpen');
  //     $('.menu_item ul').slideUp('400');
  //     parent.addClass('hasOpen');
  //     parent.find('ul').slideDown('400');
  //   }
  // });
});